export { withFormContainer } from './storybook-with-form';

// export validators
export {
	validateString,
	validateSelectField,
	validateCascadingSelectField,
	validateUserPickerField,
	validateCheckboxField,
	validateComponentField,
	validateCustomTeamsField,
	validateGroupPickerField,
	validateMultiVersionsField,
	validateOrganizationsField,
	validatePriorityField,
	validateRadioSelectField,
	validateRadioGroupField,
	validateResolutionField,
	validateSingleVersionField,
	validateLabelField,
} from './validators';
export { closeMenuOnScroll, ISSUE_CREATE_MODAL_BODY_SELECTOR } from './select';
export { handleApolloError } from './handle-apollo-error';
export { preventFormSubmitOnEnterKeyPress } from './date';
export { transformProjectType } from './transform-project-type';
export { getValueFromEventOrValue } from './form';

export { transformStargateUrl, transformCreateIssueUrl } from './transform-stargate-url';

export const getFieldContainerId = (fieldId: string) => `${fieldId}-container`;
